import React from 'react';
import * as MyCells from '../../../../../utils/Cells';
import ActionMenu from '../../../../common/action/ActionMenu';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../../../common/filters/DateRangeColumnFilter';
import { MultiSelectFilterFn } from '../../../../common/filters/Filters';
import MultiSelectColumnFilter from '../../../../common/filters/MultiSelectColumnFilter';
import TextColumnFilter from '../../../../common/filters/TextColumnFilter';

export const columns = (refresh) => {
    //       private String privateId;
    //   private int publicId;
    //   private String employeeId;
    //   private String employeeName;
    //   private VacationTypeEnum type;
    //   private LocalDate startDate;
    //   private LocalDate endDate;
    //   private int days;
    return [
        {
            Header: 'Sorszám',
            accessor: 'publicId',
            id: 'publicId',
            show: true,
            className: 'idColumn center',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Munkavállaló',
            accessor: 'employeeName',
            id: 'employeeName',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Szabadság típusa',
            accessor: 'typeLabel',
            id: 'typeLabel',
            show: true,
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
        },
        {
            Header: 'Kezdő dátum',
            accessor: 'startDate',
            id: 'startDate',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Vég dátum',
            accessor: 'endDate',
            id: 'endDate',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Napok száma',
            accessor: 'days',
            id: 'days',
            show: true,
            className: 'idColumn right',
            Filter: TextColumnFilter,
        },
        {
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'vacation'} refresh={refresh} />,
        },

    ]
}